import { BadgeProps } from "@/components/ui/badge";

export enum ACCOUNT_ROLE {
  OWNER = 'owner',
  ADMIN = 'admin',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}

export const ACCOUNT_ROLE_LABELS: Record<ACCOUNT_ROLE, string> = {
  [ACCOUNT_ROLE.OWNER]: 'Owner',
  [ACCOUNT_ROLE.ADMIN]: 'Admin',
  [ACCOUNT_ROLE.EDITOR]: 'Editor',
  [ACCOUNT_ROLE.VIEWER]: 'Viewer',
};

export const ACCOUNT_ROLE_BADGES: Record<ACCOUNT_ROLE, BadgeProps['variant']> = {
  [ACCOUNT_ROLE.OWNER]: 'owner',
  [ACCOUNT_ROLE.ADMIN]: 'default',
  [ACCOUNT_ROLE.EDITOR]: 'secondary',
  [ACCOUNT_ROLE.VIEWER]: 'outline',
};
